(function () {
  "use strict";

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function activeBundle() {
    return (
      $(".bundle.active") ||
      $(".offer-card.active") ||
      $("[data-bundle-key].active") ||
      $(".bundle") ||
      $("[data-bundle-key]")
    );
  }

  function getManualQty() {
    var qtyEl = $("#qtyVal");
    var qty = parseInt(qtyEl && qtyEl.textContent ? qtyEl.textContent : "1", 10);

    return Math.max(1, Math.min(99, isNaN(qty) ? 1 : qty));
  }

  function getBundleQty() {
    var active = activeBundle();

    if (!active) return 1;

    var bundleQty =
      active.getAttribute("data-bundle-qty") ||
      active.getAttribute("data-units") ||
      "1";

    bundleQty = parseInt(bundleQty, 10);

    return Math.max(1, isNaN(bundleQty) ? 1 : bundleQty);
  }

  function getQty() {
    return getManualQty() * getBundleQty();
  }

  function variantId() {
    var active = activeBundle();
    var key = active ? active.getAttribute("data-bundle-key") : "single";
    var variants = window.BOO_PRODUCT_VARIANTS || {};

    return (
      (active && active.getAttribute("data-variant-id")) ||
      variants[key] ||
      variants.default ||
      null
    );
  }

  function toast(msg) {
    var t = $("#toast");

    if (t) {
      t.textContent = msg || "Added to cart";
      t.classList.add("show");

      setTimeout(function () {
        t.classList.remove("show");
      }, 1600);
    }
  }

  function updateCount(count) {
    var c = $("#cartCount");

    if (c && typeof count === "number") {
      c.textContent = String(count);
    }
  }

  function add(e) {
    var target =
      e.target &&
      e.target.closest &&
      e.target.closest('[data-boo-shopify-atc="true"]');

    if (!target) return;

    e.preventDefault();
    e.stopPropagation();

    if (e.stopImmediatePropagation) {
      e.stopImmediatePropagation();
    }

    var id = variantId();
    var quantity = getQty();

    if (!id) {
      toast("Choose a product variant first");
      return false;
    }

    target.disabled = true;
    target.setAttribute("aria-busy", "true");

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(id),
            quantity: quantity
          }
        ]
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error("Cart add failed");

        return fetch("/cart.js", {
          headers: {
            Accept: "application/json"
          }
        });
      })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        updateCount(cart.item_count);
        toast("Added to cart");

        setTimeout(function () {
          window.location.href = "/cart";
        }, 350);
      })
      .catch(function () {
        window.location.href = "/cart/" + id + ":" + quantity;
      })
      .finally(function () {
        target.disabled = false;
        target.removeAttribute("aria-busy");
      });

    return false;
  }

  document.addEventListener("click", add, true);

  document.addEventListener(
    "click",
    function (e) {
      var target =
        e.target &&
        e.target.closest &&
        e.target.closest('[data-boo-cart-link="true"]');

      if (!target) return;

      e.preventDefault();
      e.stopPropagation();

      if (e.stopImmediatePropagation) {
        e.stopImmediatePropagation();
      }

      window.location.href = "/cart";
    },
    true
  );
})();